'use strict';

var productBase = require('org_km_b2s/product/base');

/**
 * Updates the PDP quantity stepper with the selected variant's maximum quantity.
 */
function updateVariantQuantityLimit() {
    $('body').on('product:afterAttributeSelect', function (_event, params) {
        var product = params.data.product;
        var maxOrderQuantity = parseInt(product.maxOrderQuantity, 10);
        var $stepper = params.container.find('.quantity-stepper').first();

        if (!$stepper.length || isNaN(maxOrderQuantity)) {
            return;
        }

        var $input = $stepper.find('input');
        var currentQuantity = parseInt($input.val(), 10);
        var nextQuantity = currentQuantity > maxOrderQuantity ? maxOrderQuantity : currentQuantity;

        $stepper.attr('data-max', maxOrderQuantity).data('max', maxOrderQuantity);
        $input.val(nextQuantity).attr('data-qty', nextQuantity).prop('data-qty', nextQuantity);

        productBase.enableQuantitySteppers(params.container);
    });
}

module.exports = {
    updateVariantQuantityLimit: updateVariantQuantityLimit
};
